import React from 'react';

const CloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#3FB0E8">
        <path
          d="M17.895 5L17.895 16.106 29 16.105 29 17.895 17.895 17.895 17.895 29 16.105 29 16.106 17.895 5 17.895 5 16.105 16.106 16.106 16.105 5z"
          transform="translate(-5 -5) rotate(45 17 17)"
        />
      </g>
    </g>
  </svg>
);

export default CloseIcon;
